import {ChangeDetectionStrategy, Component, Input, NgZone, OnChanges} from '@angular/core';
import {GraphActionsService} from 'src/app/diagram-interaction/actions/graph-actions.service';
import {
  AIDVGenerationStatus,
  GENERATION_TYPE
} from 'src/app/shared/models/generation-status.interface';
import {tap} from 'rxjs/operators';

import {MapDaoService} from '../../../core/map/map-dao.service';
import {DiagramJsonHandlerService} from '../../../diagram-data/diagram-json-handler.service';
import {GenerationHandlerService} from '../../../shared/service/generation-handler.service';

const DELAY_TIME = 1000;

@Component({
  selector: 'app-dv-generation-status',
  templateUrl: 'dv-generation-status.component.html',
  styleUrls: ['dv-generation-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DvGenerationStatusComponent implements OnChanges {
  @Input() status!: AIDVGenerationStatus;
  public forceSpinner = false;

  private repositioned = false;

  constructor(
    private graphActionsService: GraphActionsService,
    private graphActionsSvc: GraphActionsService,
    private mapDaoService: MapDaoService,
    public diagramJsonSvc: DiagramJsonHandlerService,
    private generationHandlerService: GenerationHandlerService,
    private ngZone: NgZone
  ) {}

  ngOnChanges(): void {
    this.reposition();
    this.checkForZoom();
  }

  public retry(): void {
    const {type} = this.status;

    if (type === GENERATION_TYPE.TOP_LEVEL) {
      return this.retryMapGeneration();
    }

    this.retryDrilldownGeneration();
  }

  public cancel(): void {
    this.forceSpinner = true;
    this.generationHandlerService.cancelGeneration().subscribe(() => (this.forceSpinner = false));
  }

  private reposition(): void {
    if (this.status?.reposition && !this.repositioned) {
      this.repositioned = true;
      this.graphActionsService.actualSize();
    }
  }

  private checkForZoom(): void {
    if (this.status?.requestZoom) {
      setTimeout(() => this.zoom(), DELAY_TIME);
    }
  }

  private zoom() {
    this.ngZone.run(() => this.graphActionsSvc.actualSize());
  }

  private retryDrilldownGeneration(): void {
    this.generationHandlerService.retryDrilldown(this.status);
  }

  private goToRetryLink(): void {
    const {retry: {link = null, available = false} = {}} = this.status;

    if (available && link) {
      window.location.href = link;
    }
  }

  private retryMapGeneration(): void {
    const {
      map: {id: mapId}
    } = this.diagramJsonSvc.get();

    this.forceSpinner = true;

    this.mapDaoService
      .softDeleteMap(mapId)
      .pipe(tap(() => this.goToRetryLink()))
      .subscribe();
  }
}
